import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

type Props = {
	open: boolean;
	isValid: boolean;
	setOpen: (open: boolean) => void;
	title?: string;
	content: React.ReactNode;
	action: () => void;
	buttonsText?: [string?, string?];
	children?: React.ReactElement;
};

const LoginDialog = ({ open, setOpen, children, title, content, action, isValid, buttonsText = [] }: Props) => {
	const { t } = useTranslation();

	const [primaryButtonText = t('OK'), secondaryButtonText = t('Cancel')] = buttonsText;

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			{children
				? React.cloneElement(children, {
						onClick: (e: any) => {
							e?.preventDefault?.();
							handleOpen();
						}
				  })
				: undefined}
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="xs"
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{content}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={e => {
							e.preventDefault();
							action();
						}}
						color="secondary"
						autoFocus
						disabled={isValid}
					>
						{primaryButtonText}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default LoginDialog;
